import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { ApiService } from "../core";
import { PosMarketCatalogDto, PosMarketConnectedCatalogItemDto, PosMarketplaceAvailabilityDto } from "../dto";

@Injectable({ providedIn: "root" })
export class PosMarketplaceService {
  protected serviceUrl = "posMarketplace";

  private readonly connectionRecorded = new Subject<void>();

  /** Emits each time a catalog item connection is recorded on the account, so the menu can pick up the connected item. */
  readonly connectionRecorded$ = this.connectionRecorded.asObservable();

  private readonly connectionStatusChanged = new Subject<void>();

  readonly connectionStatusChanged$ = this.connectionStatusChanged.asObservable();

  constructor(protected api: ApiService) {}

  notifyConnectionStatusChanged(): void {
    this.connectionStatusChanged.next();
  }

  getAvailability(): Observable<PosMarketplaceAvailabilityDto> {
    return this.api.get<PosMarketplaceAvailabilityDto>(`${this.serviceUrl}/availability`);
  }

  getCatalog(): Observable<PosMarketCatalogDto[]> {
    return this.api.get<PosMarketCatalogDto[]>(`${this.serviceUrl}/catalog`);
  }

  getConnectedCatalogItems(): Observable<PosMarketConnectedCatalogItemDto[]> {
    return this.api.get<PosMarketConnectedCatalogItemDto[]>(`${this.serviceUrl}/catalog/items/connected`);
  }

  connectCatalogItem(code: string): Observable<void> {
    return this.api
      .post<void>(`${this.serviceUrl}/catalog/items/${encodeURIComponent(code)}/connect`)
      .pipe(tap(() => this.connectionRecorded.next()));
  }

  /** Drops the connection the account started and has not finished. */
  cancelConnection(): Observable<void> {
    return this.api.post<void>(`${this.serviceUrl}/connection/cancel`).pipe(tap(() => this.connectionRecorded.next()));
  }

  disconnect(): Observable<void> {
    return this.api.post<void>(`${this.serviceUrl}/connection/disconnect`).pipe(tap(() => this.connectionRecorded.next()));
  }
}
